import Card from "./card.js";
export default class Banner extends Card {
  constructor(s, t, i, h, r, e, n, l, a, o, u, c, d, p) {
    super(s, t, null, i, null, h, r, e, n, l, a, o, u, c, d, p),
      (this.Y = "ab-banner"),
      (this.Z = !1);
  }
  ss() {
    const s = {};
    return (
      (s[Card.hs.ts] = Card.es.rs),
      (s[Card.hs.ns] = this.id),
      (s[Card.hs.ls] = this.viewed),
      (s[Card.hs.os] = this.imageUrl),
      (s[Card.hs.us] = this.updated),
      (s[Card.hs.cs] = this.created),
      (s[Card.hs.ds] = this.categories),
      (s[Card.hs.ps] = this.expiresAt),
      (s[Card.hs.URL] = this.url),
      (s[Card.hs.bs] = this.linkText),
      (s[Card.hs.fs] = this.aspectRatio),
      (s[Card.hs.xs] = this.extras),
      (s[Card.hs.js] = this.pinned),
      (s[Card.hs.zs] = this.dismissible),
      (s[Card.hs.gs] = this.clicked),
      (s[Card.hs.ks] = this.test),
      s
    );
  }
}
